import {useAuth} from '../../../../../app/modules/auth'
import {AdminMenu} from './AdminMenu'
import {LecturerMenu} from './LecturerMenu'
import {StudentMenu} from './StudentMenu'

export function MenuInner() {
  const {currentUser} = useAuth()
  return (
    <>
      {currentUser?.position !== 'Lecturer' && currentUser?.position !== 'Student' && <AdminMenu />}
      {currentUser?.position === 'Lecturer' && <LecturerMenu />}
      {currentUser?.position === 'Student' && <StudentMenu />}
    </>
  )
}
